// extracted by mini-css-extract-plugin
export default {"drawerDesktop":"style_drawerDesktop__QZlOe"};